'use client'
import React from 'react'

export default function SeePasswordButton({ seePassword, setSeePassword }) {
  return (
    <button className='absolute bottom-3 right-3' type='button' onClick={() => setSeePassword(!seePassword)}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" width="24" height="24" strokeWidth="2">
        {
          seePassword ?
            <>
              <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
              <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
            </>
            :
            <>
              <path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"></path>
              <path d="M3 15l2.5 -3.8"></path>
              <path d="M21 14.976l-2.492 -3.776"></path>
              <path d="M9 17l.5 -4"></path>
              <path d="M15 17l-.5 -4"></path>
            </>
        }
      </svg>
    </button>
  )
}
